// import { createSlice } from "@reduxjs/toolkit";

// const getCartKey = (restaurantId) => `cart_${restaurantId}`;

// const buildItemKey = (item) =>
//   `${item._id}__${item.selectedSize || ""}__${item.selectedVariant || ""}__${JSON.stringify(item.selectedAddons || [])}`;

// const loadCartFromStorage = (restaurantId) => {
//   try {
//     const stored = localStorage.getItem(getCartKey(restaurantId));
//     return stored ? JSON.parse(stored) : [];
//   } catch {
//     return [];
//   }
// };

// const saveCartToStorage = (restaurantId, items) => {
//   try {
//     localStorage.setItem(getCartKey(restaurantId), JSON.stringify(items));
//   } catch (e) {
//     console.error("Cart save error:", e);
//   }
// };

// const cartSlice = createSlice({
//   name: "cart",
//   initialState: {
//     items: [],
//     restaurantId: null,
//     updateOrderId: null,
//   },
//   reducers: {
//     setRestaurant: (state, action) => {
//       const restaurantId = action.payload;
//       state.restaurantId = restaurantId;
//       state.items = loadCartFromStorage(restaurantId);
//     },

//     setUpdateOrderId: (state, action) => {
//       state.updateOrderId = action.payload;
//     },

//     clearUpdateOrderId: (state) => {
//       state.updateOrderId = null;
//     },

//     addItem: (state, action) => {
//       const item = action.payload;
//       if (!state.restaurantId) return;

//       const itemKey = buildItemKey(item);
//       const existing = state.items.find((i) => buildItemKey(i) === itemKey);

//       if (existing) {
//         existing.qty += 1;
//       } else {
//         state.items.push({ ...item, qty: 1 });
//       }
//       saveCartToStorage(state.restaurantId, state.items);
//     },

//     removeItem: (state, action) => {
//       const payload = action.payload;
//       if (!state.restaurantId) return;

//       const isObject = typeof payload === "object" && payload !== null;
//       const matchFn = isObject
//         ? (i) => buildItemKey(i) === buildItemKey(payload)
//         : (i) => i._id === payload;

//       const index = state.items.findIndex(matchFn);
//       if (index === -1) return;

//       const item = state.items[index];
//       if (item.qty > 1) {
//         item.qty -= 1;
//       } else {
//         state.items.splice(index, 1);
//       }
//       saveCartToStorage(state.restaurantId, state.items);
//     },

//     clearCart: (state) => {
//       if (state.restaurantId) {
//         localStorage.removeItem(getCartKey(state.restaurantId));
//       }
//       state.items = [];
//       state.updateOrderId = null;
//     },

//     clearRestaurantCart: (state, action) => {
//       const restaurantId = action.payload;
//       localStorage.removeItem(getCartKey(restaurantId));
//       if (state.restaurantId === restaurantId) {
//         state.items = [];
//         state.updateOrderId = null;
//       }
//     },

//     resetCart: (state) => {
//       state.items = [];
//       state.restaurantId = null;
//       state.updateOrderId = null;
//     },

//     updateCartWithOffers: (state, action) => {
//   const { freeItems = [] } = action.payload;
//   if (!state.restaurantId) return;

//   // 🔥 Agar freeItems khaali hain to kuch mat karo
//   if (freeItems.length === 0) {
//     console.log("⏭️ updateCartWithOffers: no free items to add");
//     return;
//   }

//   // 🔥 Check karo ki already same free items hain kya
//   const currentFreeItems = state.items.filter((item) => item.isFree);

//   // Compare karo current vs new
//   const itemsChanged =
//     currentFreeItems.length !== freeItems.length ||
//     freeItems.some((fi) => {
//       const existing = currentFreeItems.find(
//         (ef) =>
//           ef._id === fi.itemId &&
//           ef.appliedOffer?.offerId?.toString() === fi.offerId?.toString()
//       );
//       return !existing || existing.qty !== fi.quantity;
//     });

//   // 🔥 Agar kuch change nahi hua to skip karo (infinite loop prevent)
//   if (!itemsChanged) {
//     console.log("⏭️ updateCartWithOffers: no changes detected, skipping");
//     return;
//   }
//  // 🔥 Sirf BOGO items process karo
//   const bogoFreeItems = freeItems.filter(
//     (fi) => fi.offerCategory === "BOGO"
//   );

//   if (bogoFreeItems.length === 0) return;

//   // Purane free items hatao
//   state.items = state.items.filter((item) => !item.isFree);

//   // Naye free items add karo
//   freeItems.forEach((freeItem) => {
//     const originalItem = state.items.find(
//       (i) => i._id === freeItem.itemId && !i.isFree
//     );

//     if (originalItem) {
//       state.items.push({
//         ...originalItem,
//         _id: originalItem._id,
//         itemName: originalItem.itemName.replace(" (FREE)", "").trim(),
//         qty: freeItem.quantity,
//         isFree: true,
//         price: 0,
//         discountedPrice: 0,
//         originalPrice: freeItem.price || originalItem.originalPrice,
//         appliedOffer: {
//           offerId: freeItem.offerId,
//           offerCode: freeItem.offerCode,
//           offerTitle: freeItem.offerTitle,
//           offerCategory: freeItem.offerCategory,
//           isFree: true,
//           discountAmount: freeItem.discountAmount || 0,
//         },
//       });
//     } else {
//       state.items.push({
//         _id: freeItem.itemId,
//         itemName: freeItem.itemName,
//         qty: freeItem.quantity,
//         isFree: true,
//         price: 0,
//         discountedPrice: 0,
//         originalPrice: freeItem.price || 0,
//         appliedOffer: {
//           offerId: freeItem.offerId,
//           offerCode: freeItem.offerCode,
//           offerTitle: freeItem.offerTitle,
//           offerCategory: freeItem.offerCategory,
//           isFree: true,
//           discountAmount: freeItem.discountAmount || 0,
//         },
//       });
//     }
//   });

//   saveCartToStorage(state.restaurantId, state.items);
// },
//   },
// });

// export const {
//   addItem,
//   removeItem,
//   clearCart,
//   setRestaurant,
//   clearRestaurantCart,
//   resetCart,
//   updateCartWithOffers,
//   setUpdateOrderId,
//   clearUpdateOrderId,
// } = cartSlice.actions;

// export const selectCartItems = (state) => state.cart.items;
// export const selectCartRestaurant = (state) => state.cart.restaurantId;

// // export const selectCartItemCount = (state) =>
// //   state.cart.items.reduce((t, i) => t + (i.qty || 1), 0);

// export const selectCartItemCount = (state) =>
//   state.cart.items.reduce((t, i) => {
//     if (i.isFree) return t;   // 🔥 Free skip
//     return t + (i.qty || 1);
//   }, 0);

// export const selectUpdateOrderId = (state) => state.cart.updateOrderId;

// // 🔥 FIXED: Subtotal = sirf non-free items ka original total
// export const selectCartSubtotal = (state) => {
//   return state.cart.items.reduce((total, item) => {
//     if (item.isFree) return total;
//     const originalPrice =
//       item.originalPrice || item.basePrice || item.price || 0;
//     return total + originalPrice * (item.qty || 1);
//   }, 0);
// };

// export const selectCartTotal = (state) => {
//   return state.cart.items.reduce((total, item) => {
//     if (item.isFree) return total;
//     const price = item.discountedPrice || item.price || 0;
//     return total + price * (item.qty || 1);
//   }, 0);
// };

// export const selectCartTotalDiscount = (state) => {
//   return state.cart.items.reduce((total, item) => {
//     if (item.isFree) return total;
//     const originalPrice =
//       item.originalPrice || item.basePrice || item.price || 0;
//     const currentPrice = item.discountedPrice || item.price || 0;
//     if (originalPrice > currentPrice) {
//       return total + (originalPrice - currentPrice) * (item.qty || 1);
//     }
//     return total;
//   }, 0);
// };

// export const selectFreeItemsCount = (state) => {
//   return state.cart.items.reduce((count, item) => {
//     if (item.isFree) return count + (item.qty || 1);
//     return count;
//   }, 0);
// };

// export default cartSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const getCartKey = (restaurantId) => `cart_${restaurantId}`;

// ⭐ FIXED: buildItemKey handles both Object { name: 'L' } and String 'L'
const buildItemKey = (item) => {
  const sizeKey =
    typeof item.selectedSize === "object" && item.selectedSize !== null
      ? item.selectedSize.name || ""
      : item.selectedSize || "";

  const variantKey =
    typeof item.selectedVariant === "object" && item.selectedVariant !== null
      ? item.selectedVariant.name || ""
      : item.selectedVariant || "";

  const addonsKey = Array.isArray(item.selectedAddons)
    ? item.selectedAddons
        .map((a) => (typeof a === "object" && a !== null ? a.name || "" : a))
        .sort()
        .join(",")
    : "";

  return `${item._id || item.itemId}__${sizeKey}__${variantKey}__${addonsKey}`;
};

const loadCartFromStorage = (restaurantId) => {
  try {
    const stored = localStorage.getItem(getCartKey(restaurantId));
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

const saveCartToStorage = (restaurantId, items) => {
  try {
    localStorage.setItem(getCartKey(restaurantId), JSON.stringify(items));
  } catch (e) {
    console.error("Cart save error:", e);
  }
};

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    items: [],
    restaurantId: null,
    updateOrderId: null,
  },
  reducers: {
    setRestaurant: (state, action) => {
      const restaurantId = action.payload;
      state.restaurantId = restaurantId;
      state.items = loadCartFromStorage(restaurantId);
    },

    setUpdateOrderId: (state, action) => {
      state.updateOrderId = action.payload;
    },

    clearUpdateOrderId: (state) => {
      state.updateOrderId = null;
    },

    addItem: (state, action) => {
      const item = action.payload;
      if (!state.restaurantId) return;

      const itemKey = buildItemKey(item);
      const existing = state.items.find((i) => buildItemKey(i) === itemKey);

      if (existing) {
        existing.qty += 1;
      } else {
        state.items.push({ ...item, qty: 1 });
      }
      saveCartToStorage(state.restaurantId, state.items);
    },

    removeItem: (state, action) => {
      const payload = action.payload;
      if (!state.restaurantId) return;

      const isObject = typeof payload === "object" && payload !== null;
      const matchFn = isObject
        ? (i) => buildItemKey(i) === buildItemKey(payload)
        : (i) => i._id === payload;

      const index = state.items.findIndex(matchFn);
      if (index === -1) return;

      const item = state.items[index];
      if (item.qty > 1) {
        item.qty -= 1;
      } else {
        state.items.splice(index, 1);
      }
      saveCartToStorage(state.restaurantId, state.items);
    },

    clearCart: (state) => {
      if (state.restaurantId) {
        localStorage.removeItem(getCartKey(state.restaurantId));
      }
      state.items = [];
      state.updateOrderId = null;
    },

    clearRestaurantCart: (state, action) => {
      const restaurantId = action.payload;
      localStorage.removeItem(getCartKey(restaurantId));
      if (state.restaurantId === restaurantId) {
        state.items = [];
        state.updateOrderId = null;
      }
    },

    resetCart: (state) => {
      state.items = [];
      state.restaurantId = null;
      state.updateOrderId = null;
    },

    updateCartWithOffers: (state, action) => {
      const { freeItems = [] } = action.payload;
      if (!state.restaurantId) return;

      if (freeItems.length === 0) {
        console.log("⏭️ updateCartWithOffers: no free items to add");
        return;
      }

      const currentFreeItems = state.items.filter((item) => item.isFree);

      const itemsChanged =
        currentFreeItems.length !== freeItems.length ||
        freeItems.some((fi) => {
          const existing = currentFreeItems.find(
            (ef) =>
              ef._id === fi.itemId &&
              ef.appliedOffer?.offerId?.toString() === fi.offerId?.toString()
          );
          return !existing || existing.qty !== fi.quantity;
        });

      if (!itemsChanged) {
        console.log("⏭️ updateCartWithOffers: no changes detected, skipping");
        return;
      }

      const bogoFreeItems = freeItems.filter(
        (fi) => fi.offerCategory === "BOGO"
      );

      if (bogoFreeItems.length === 0) return;

      // Purane free items hatao
      state.items = state.items.filter((item) => !item.isFree);

      // Naye free items add karo
      freeItems.forEach((freeItem) => {
        const originalItem = state.items.find(
          (i) => i._id === freeItem.itemId && !i.isFree
        );

        if (originalItem) {
          state.items.push({
            ...originalItem,
            _id: originalItem._id,
            itemName: originalItem.itemName.replace(" (FREE)", "").trim(),
            qty: freeItem.quantity,
            isFree: true,
            price: 0,
            discountedPrice: 0,
            originalPrice: freeItem.price || originalItem.originalPrice,
            appliedOffer: {
              offerId: freeItem.offerId,
              offerCode: freeItem.offerCode,
              offerTitle: freeItem.offerTitle,
              offerCategory: freeItem.offerCategory,
              isFree: true,
              discountAmount: freeItem.discountAmount || 0,
            },
          });
        } else {
          state.items.push({
            _id: freeItem.itemId,
            itemName: freeItem.itemName,
            qty: freeItem.quantity,
            isFree: true,
            price: 0,
            discountedPrice: 0,
            originalPrice: freeItem.price || 0,
            appliedOffer: {
              offerId: freeItem.offerId,
              offerCode: freeItem.offerCode,
              offerTitle: freeItem.offerTitle,
              offerCategory: freeItem.offerCategory,
              isFree: true,
              discountAmount: freeItem.discountAmount || 0,
            },
          });
        }
      });

      saveCartToStorage(state.restaurantId, state.items);
    },
  },
});

export const {
  addItem,
  removeItem,
  clearCart,
  setRestaurant,
  clearRestaurantCart,
  resetCart,
  updateCartWithOffers,
  setUpdateOrderId,
  clearUpdateOrderId,
} = cartSlice.actions;

export const selectCartItems = (state) => state.cart.items;
export const selectCartRestaurant = (state) => state.cart.restaurantId;

export const selectCartItemCount = (state) =>
  state.cart.items.reduce((t, i) => {
    if (i.isFree) return t;
    return t + (i.qty || 1);
  }, 0);

export const selectUpdateOrderId = (state) => state.cart.updateOrderId;

export const selectCartSubtotal = (state) => {
  return state.cart.items.reduce((total, item) => {
    if (item.isFree) return total;
    const originalPrice =
      item.originalPrice || item.basePrice || item.price || 0;
    return total + originalPrice * (item.qty || 1);
  }, 0);
};

export const selectCartTotal = (state) => {
  return state.cart.items.reduce((total, item) => {
    if (item.isFree) return total;
    const price = item.discountedPrice || item.price || 0;
    return total + price * (item.qty || 1);
  }, 0);
};

export const selectCartTotalDiscount = (state) => {
  return state.cart.items.reduce((total, item) => {
    if (item.isFree) return total;
    const originalPrice =
      item.originalPrice || item.basePrice || item.price || 0;
    const currentPrice = item.discountedPrice || item.price || 0;
    if (originalPrice > currentPrice) {
      return total + (originalPrice - currentPrice) * (item.qty || 1);
    }
    return total;
  }, 0);
};

export const selectFreeItemsCount = (state) => {
  return state.cart.items.reduce((count, item) => {
    if (item.isFree) return count + (item.qty || 1);
    return count;
  }, 0);
};

export default cartSlice.reducer;